import MarketMakingOrderBookPanel from "src/Components/MarketMakingOrderBookPanel";
import BaseSymbolBoard from "./BaseSymbolBoard";
import { getBasePriceRange } from "./getBasePriceRange";
import useLiveOrderBooks from "src/Hooks/useLiveOrderBooks";
import useOrderBookPolling from "src/Pages/AutomaticMarketMaking/Execusion/useOrderBookPolling";
import {
  BaseExecutionTaskRow,
  getBaseExecutionMarketData,
  getBaseExecutionOrderBook,
} from "src/Requests/baseMarketMaking";

interface Props { task: BaseExecutionTaskRow | null }

const ExecutionOrderBook = ({ task }: Props) => {
  const polling = useOrderBookPolling(task?.id, getBaseExecutionOrderBook);
  const market = useOrderBookPolling(task?.id, getBaseExecutionMarketData);
  const live = useLiveOrderBooks({
    enabled: !!task,
    instrumentIds: task ? [task.instrumentId] : [],
  });
  const overview = polling.response && "fullOrderBook" in polling.response
    ? polling.response : null;
  const polledOrderBook = overview ? overview.fullOrderBook :
    polling.response && "bestLimitsDto" in polling.response ? polling.response : null;
  const instrumentStatistic = market.response?.instrumentStatistic ?? null;
  const liveDetails = market.response?.liveDetails ?? null;
  const priceRange = getBasePriceRange(liveDetails, instrumentStatistic, task);
  const orderBook = live.resolveOrderBook(polledOrderBook, task?.instrumentId);
  const namedOrderBook = orderBook && task ? {
    ...orderBook,
    namad: task.symbol || orderBook.namad,
    fullName: task.instrumentName || task.symbol || orderBook.fullName,
    tseLink: task.tseLink || orderBook.tseLink,
  } : orderBook;

  return <MarketMakingOrderBookPanel
    mode="base"
    orderBook={namedOrderBook}
    openOrders={task ? overview?.openOrders ?? [] : undefined}
    board={<BaseSymbolBoard task={task} statistic={instrumentStatistic}
      live={liveDetails} openOrders={overview?.openOrders ?? []} />}
    details={task ? { baseInsPriceLive: liveDetails?.baseInsPriceLive,
      baseInsPriceYesterday: liveDetails?.baseInsPriceYesterday,
      liveFairPrice: liveDetails?.liveFairPrice,
      lastFactorTriggerAt: liveDetails?.lastFactorTriggerAt,
      closingPrice: liveDetails?.closingPrice, midpoint: liveDetails?.midpoint,
      minPricePermit: priceRange?.min,
      maxPricePermit: priceRange?.max,
      priceYesterday: instrumentStatistic?.priceYesterday } : null}
  />;
};

export default ExecutionOrderBook;
